import { uploadUrl } from "./assets";

/** @typedef {import("../data/albums").AlbumPhoto} AlbumPhoto */

/** @param {AlbumPhoto} photo */
export function albumPhotoBackground(photo) {
  if (photo.image) {
    return `url('${uploadUrl(photo.image)}') center/cover`;
  }
  return photo.grad ?? "#161412";
}

export { masonryColumnCount } from "./photographyUtils";
